<template>
  <div>
    <div class="block-content" v-if="!isOnSettingsMenu">
      <div
        class="mr-0 form-check form-check-inline"
      >
        <div class="custom-control custom-checkbox" @click.capture="openModalUpgrade">
          <input
            type="checkbox"
            class="custom-control-input"
            id="check-qna-moderation"
            :disabled="isShowTooltip"
            v-model="$store.state.presentation.isModerationMode"
            @change="handleCheckBox()"
          >

          <label
            class="custom-control-label"
            for="check-qna-moderation"
          >
            {{ $i18nPresenter.t("Moderate audience’s questions") }}
          </label>
          <span class="pl-1 title-table-presentation-tooltip" v-if="!isShowTooltip">
            <b-button
              v-tooltip="moderationToolTip"
              class="tooltip-btn"
            />
            <i class="fas fa-question-circle" />
          </span>
          <div class="relative inline-block ml-2" v-else>
            <img src="@/assets/images/pro.svg" class="cursor-pointer" @click="openModalUpgrade()" />
            <PlanUpgradeModal
              :name-feature="'Moderation'"
              :is-show-tooltip="ctaUpgradePresentationMorderation"
              @outsideEvent="clickOutsideUpPresentationMorderation"
            >
              <template #tooltipcontent>
                <div>
                  {{ $i18nPresenter.t("Approve or dismiss questions before they are shown on the presenter's screen.") }}
                  <div class="mt-2">
                    {{ $i18nPresenter.t("Unavailable in your current plan.") }}
                  </div>
                </div>
              </template>
            </PlanUpgradeModal>
            <div v-if="ctaUpgradePresentationMorderation" class="upgrade-arrow upgrade-arrow_slide"></div>
          </div>
        </div>

        <QnAModerationLink v-if="$store.state.presentation.isModerationMode" />
      </div>
    </div>
    <!-- Moderation on Header Settings -->
    <div
      v-if="isOnSettingsMenu"
      class="mb-3 settings-moderation-wrapper"
    >
      <div @click.capture="openModalUpgrade" class="inline-block">
        <aha-checkbox

          id="settings-check-qna-moderation"
          v-model="$store.state.presentation.isModerationMode"
          :disabled="isShowTooltip"
          @change="handleCheckBox()"
        >
          <span>{{ $i18nPresenter.t("Moderate audience’s questions") }}
            <aha-icon
              v-if="!isShowTooltip"
              class="ml-1 text-base-70"
              name="question"
              viewBox="0 0 24 24"
              width="15"
              height="15"
              v-tooltip="moderationToolTip"
            />
          </span>
        </aha-checkbox>
      </div>
      <div class="relative inline-block ml-2" v-if="isShowTooltip">
        <img src="@/assets/images/pro.svg" class="cursor-pointer" @click="openModalUpgrade()" />
        <PlanUpgradeModal
          :name-feature="'Moderation'"
          :is-show-tooltip="ctaUpgradePresentationMorderation"
          @outsideEvent="clickOutsideUpPresentationMorderation"
        >
          <template #tooltipcontent>
            <div>
              {{ $i18nPresenter.t("Approve or dismiss questions before they are shown on the presenter's screen.") }}
              <div class="mt-2">
                {{ $i18nPresenter.t("Unavailable in your current plan.") }}
              </div>
            </div>
          </template>
        </PlanUpgradeModal>
        <div v-if="ctaUpgradePresentationMorderation" class="upgrade-arrow upgrade-arrow_slide"></div>
      </div>
      <QnAModerationLink v-if="$store.state.presentation.isModerationMode" />
    </div>
    <!-- End of Moderation on Header Settings -->
  </div>
</template>

<script>
import QnAModerationLink from '@/components/presentations/QnAModerationLink.vue'
import QnAModerationLinkContainer from '@/containers/qna-moderation/QnAModerationLink'
import PlanUpgradeModal from '@/components-v2/presentation-editor/editor-header/PlanUpgrade.vue'

export default {
  components: {
    PlanUpgradeModal,
    QnAModerationLink: QnAModerationLinkContainer(QnAModerationLink),
  },
  props: {
    isOnSettingsMenu: {
      type: Boolean,
      default: false,
    },
    handleCheckBoxModeration: {
      type: Function,
      default: () => {},
    },
  },

  data() {
    return {
      ctaUpgradePresentationMorderation: false,
    }
  },
  computed: {
    moderationToolTip() {
      return this.$i18nPresenter.t("Use the link provided to approve and dismiss questions before they are shown on the presenter's screen")
    },
    isWhiteLabel() {
      return this.$store.state.plan.group === 'white-label'
    },
    isProPlan() {
      return this.$store.state.plan.group === 'pro'
    },
    isEduLarge() {
      return this.$store.state.plan.type == 'edu-large-yearly'
    },
    isBeforeCurrentPeriodStart() {
      return this.$store.state.currentUser.isBeforeCurrentPeriodStart
    },
    isPlanFree() {
      return this.$store.state.plan && this.$store.state.plan.group === 'free'
    },
    isShowTooltip() {
      return this.isBeforeCurrentPeriodStart ? !(this.isProPlan || this.isWhiteLabel || this.isEduLarge) : false
    },
    bindingCheckbox: {
      get() {
        if (this.isShowTooltip) {
          return false
        }
        return this.$store.state.presentation.isModerationMode
      },
    },
  },
  methods: {

    clickOutsideUpPresentationMorderation() {
      this.ctaUpgradePresentationMorderation = false
    },
    openModalUpgrade() {
      if (this.isShowTooltip) {
        this.ctaUpgradePresentationMorderation = true
      }
    },
    handleCheckBox() {
      if (this.isShowTooltip) {
        this.openModalUpgrade()
        return
      }
      this.handleCheckBoxModeration()
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss-v2/variables.scss';

.settings-moderation-wrapper.disabled {
  color: $disabled-text;
  @apply italic;
  ::v-deep .checkbox-component-wrapper {
    background-color: $disabled-input;
  }
}
.upgrade-arrow {
  width: 0;
  height: 0;
  border-width: 0 8px 8px 8px;
  border-color: transparent transparent rgba(40, 46, 62, var(--tw-bg-opacity)) transparent;
  border-style: solid;
  position: absolute;
  z-index: 1;
  top: 1.6rem;

  &.upgrade-arrow_presentation {
    left: calc(50% - 47px);
  }

  &.upgrade-arrow_slide {
    left: 10%;
  }
}
</style>
